export const FILTERED_AUTHOR = "filters/filtered_author";
export const FILTERED_CATEGORY = "filters/filtered_category";
export const FILTERED_TITLE = "filters/filtered_title";
